export default __webpack_public_path__ + "static/media/330_business06-jp-mobile.debb8332.png";